import { Component, OnInit, inject } from '@angular/core';
import { Background } from '../../shared/components/background/background';
import { Connect } from '../../shared/components/connect/connect';
import { SeoService } from '../../shared/services/seo.service';

@Component({
  selector: 'app-privacy-policy',
  imports: [Background, Connect],
  templateUrl: './privacy-policy.html',
  styleUrl: './privacy-policy.scss'
})
export class PrivacyPolicy implements OnInit {

  private seo = inject(SeoService);

  ngOnInit() {
    this.seo.apply({
      title: 'Privacy Policy',
      description: 'Read SEM Nexus’ privacy policy covering data usage, collection, security measures, and your rights across our development and marketing services.',
      canonical: '/privacy-policy/',
      type: 'website',
    });
    this.seo.setBreadcrumbs([
      { name: 'Home', url: '/' },
      { name: 'Privacy Policy' },
    ]);
  }
}
